import { Directive, inject, TemplateRef } from '@angular/core';

export interface AdminTableRowContext<T> {
  $implicit: T;
  index: number;
}

/** `<ng-template adminTableHeader>` — the header row(s), rendered inside `<thead>`. */
@Directive({ selector: 'ng-template[adminTableHeader]', standalone: true })
export class AdminTableHeaderDirective {
  readonly template = inject(TemplateRef);
}

/** `<ng-template adminTableRow let-row>` — one `<tr>` per row. */
@Directive({ selector: 'ng-template[adminTableRow]', standalone: true })
export class AdminTableRowDirective<T = unknown> {
  readonly template = inject<TemplateRef<AdminTableRowContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(_dir: AdminTableRowDirective<T>, _ctx: unknown): _ctx is AdminTableRowContext<T> {
    return true;
  }
}

/** `<ng-template adminTableEmpty>` — shown instead of rows when there are none. */
@Directive({ selector: 'ng-template[adminTableEmpty]', standalone: true })
export class AdminTableEmptyDirective {
  readonly template = inject(TemplateRef);
}
